import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { styled } from "../styled";
import { Button } from "../button";
import { Input } from "../input/input";
import { Modal } from "../modal/modal";
import { useEnterPressed } from "../web/keypress";
import { useFontAwesomeIcon } from "../platform";
import { useTheme } from "../theme";
const Card = styled("div", ({ $theme }) => ({
    background: $theme.background3,
    color: $theme.foreground,
    padding: 20,
    borderRadius: 10,
    minHeight: 150,
    width: 450,
    display: "flex",
    flexDirection: "column",
    gap: 5,
    fontFamily: 'hiyllo, sans-serif',
}));
const Header = styled("div", ({ $theme }) => ({
    color: $theme.foreground,
    fontSize: 24,
    fontWeight: "bold",
}));
const Message = styled("div", ({ $theme }) => ({
    color: $theme.foreground,
    fontSize: 16,
}));
const ButtonRow = styled("div", ({ $theme }) => ({
    display: "flex",
    flexDirection: "row",
    gap: 10,
}));
const EnterHint = styled("div", ({ $theme }) => ({
    display: "inline-block",
    color: $theme.foreground,
    borderWidth: 1,
    borderColor: $theme.foreground,
    borderStyle: "solid",
    fontSize: "10px",
    lineHeight: "10px",
    paddingTop: "2.5px",
    paddingBottom: "2.5px",
    paddingLeft: "5px",
    paddingRight: "5px",
    borderRadius: "2.5px"
}));
export const DialogWeb = React.memo(function DialogWeb(props) {
    const inputRef = React.useRef(null);
    const [confirming, setConfirming] = React.useState(false);
    const onConfirm = React.useCallback(async () => {
        setConfirming(true);
        if ('onConfirm' in props) {
            await props.onConfirm?.(inputRef.current?.value ?? "");
        }
        setConfirming(false);
    }, [props]);
    React.useEffect(() => {
        // @ts-expect-error zzz
        document.activeElement?.blur();
        inputRef.current?.focus();
    }, []);
    const closeAnd = React.useCallback((fn) => {
        return () => {
            props.onClose();
            fn();
        };
    }, [props]);
    const onEnterPressed = React.useCallback(() => {
        const hasEnterPress = props.buttons.some(button => button.onClick === 'submit');
        if (hasEnterPress) {
            onConfirm();
        }
    }, [onConfirm]);
    useEnterPressed(onEnterPressed);
    const FontAwesomeIcon = useFontAwesomeIcon();
    const $theme = useTheme();
    return (_jsx(Modal, { onClose: props.onClose, children: _jsxs(Card, { children: [props.icon != null ?
                    "src" in props.icon ?
                        _jsx("img", { src: props.icon.src, style: { width: 40, height: 40, objectFit: "contain" } })
                        :
                            _jsx(FontAwesomeIcon, { icon: props.icon, size: 40, color: $theme.foreground })
                    : null, _jsx(Header, { children: props.title }), _jsx(Message, { children: props.message }), props.requireValue === true ? (_jsx(Input, { ref: inputRef, defaultValue: props.defaultValue, autoFocus: true, type: props.password === true ? "password" : "text", startEnhancer: props.inputStartEnhancer })) : null, props.extras, _jsx("div", { style: { height: 0, flexGrow: 1 } }), _jsx(ButtonRow, { children: props.buttons.map((button, i) => {
                        return (_jsx(Button, { label: _jsxs(_Fragment, { children: [button.label, button.onClick === 'submit' ? _jsx(EnterHint, { children: "Enter" }) : null] }), onClick: button.onClick === 'submit' ? onConfirm : closeAnd(button.onClick), isLoading: confirming, isSecondary: button.type === 'secondary' }));
                    }) })] }) }));
});
